import React, { FC, useState } from 'react';
import { AuthConsumer } from '../AuthProvider';
import SandBoxLogo from '../../../assets/SandBoxSystem@3x.png';
import Footer from '../../../assets/footer.jpg';
import './Login.scss';

const Login: FC = (): React.ReactElement => {
    const [email, setEmail] = useState('');

    return (
        <AuthConsumer>
            {({ userManager }): React.ReactElement => {
                return (
                    <div className="Login">
                        <div className="Login-Container">
                            <img className="Login-Logo" src={SandBoxLogo} alt="SandBox Logo" />
                            <form
                                className="Login-Form"
                                onSubmit={(e): void => {
                                    e.preventDefault();
                                    userManager.signinRedirect({
                                        // eslint-disable @typescript-eslint/camelcase
                                        login_hint: email,
                                        prompt: 'login',
                                    });
                                }}
                            >
                                <input
                                    autoFocus
                                    className="Login-Form-Email"
                                    type="email"
                                    placeholder="EMAIL"
                                    required
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                />
                                <button type="submit" className="Login-Form-Button" disabled={email === ''}>
                                    Login
                                </button>
                            </form>
                            <div className="Login-Help">
                                <span className="Login-Help-Description">
                                    Having trouble logging in? Contact the Help Desk.
                                </span>
                                <div className="Login-Help-Contact">
                                    <span className="Login-Help-Phone">
                                        <i className="material-icons Login-Help-Icon">phone</i>
                                        <span>(844) IT4-SLCA</span>
                                    </span>
                                    <span className="Login-Help-Email">
                                        <i className="material-icons Login-Help-Icon">email</i>
                                        <a href="mailto:servicedesk@ussilica.com">servicedesk@ussilica.com</a>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <footer className="Login-Footer">
                            <img className="Login-Footer-Asset" src={Footer} alt="Workflow process" />
                            <div className="Login-Footer-Top" />
                            <div className="Login-Footer-Bottom" />
                        </footer>
                    </div>
                );
            }}
        </AuthConsumer>
    );
};

export default Login;

